import { IntentCell } from "@similarweb/pro-logic-components";

import { NO_DATA_SIGN } from "app/filters/const";
import type { IIntent } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

interface IStatusIntentProps<T extends string> {
    status: T;
    config: Record<T, IIntent>;
    dataAutomation?: string;
}

export const StatusIntent = <T extends string>({
    status,
    config,
    dataAutomation = "status-intent",
}: IStatusIntentProps<T>) => {
    const intent: IIntent = config?.[status];

    return intent ? (
        <IntentCell
            data-automation={dataAutomation}
            label={intent.label || status}
            bgColor={intent.color}
            textColor={intent.textColor}
        />
    ) : (
        NO_DATA_SIGN
    );
};
